/* eslint-disable */ 
import React from 'react'; 
import ContentsList from '../modules/ContentsList';

export default function NewsList(prop) {
    return ( 
        <ContentsList lang={prop.lang} type={prop.type} />
    ); 
}; 